import { LoadablePaint } from '@confluence/loadable';

export const ViewPageLiteHeaderLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ViewPageLiteHeader" */ '../src/ViewPageLiteHeader'
			)
		).ViewPageLiteHeader,
});
